var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-btn",class:{"open": _vm.open}},[_c('span',{staticClass:"line line--horizontal"}),_vm._v(" "),_c('span',{staticClass:"line line--vertical"})])}
var staticRenderFns = []

export { render, staticRenderFns }